import styled from 'styled-components';

export const DropdownWrapper = styled.ul`
  padding: 0 16px;
  list-style: none;
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`;

export const DropdownItemWrapper = styled.li`
  white-space: nowrap;

  a {
    display: block;
    padding: 16px 0;
    color: #333f48;
    font-size: 16px;

    &:hover {
      color: #0081c6;
    }
  }

  &:not(:first-child) {
    border-top: 1px solid #e9ebed;
  }
`;
